
import { IIconsProps } from "components/Icons/icons.model"

const CustomPoliticaVenda = (props: IIconsProps) => {
    return (
        <i id={props.id} className="fa-solid fa-user-gear" style={{ fontSize: props.fontSize, color: props.color, ...props.style }} />
    )
}

export default CustomPoliticaVenda;